import { v4 as uuidv4 } from 'uuid';

const initialState = {
  types: [
    { id: 1, label: 'Uncategorized', color: '#E5E5E5', type: 'default' }
  ],
  panel: "All"
}

export default function project(state = initialState, action) {
  switch (action.type) {
    case 'ADD_PROJECT_TYPE':
      const type = {
        id: '',
        label: '',
        color: '',
        type: ''
      };

      const newType = {
        ...type,
        id: uuidv4(),
        label: action.new_type.label,
        color: action.new_type.color,
        type: 'custom'
      }

      return {
        ...state,
        types: [...state.types, newType],
      }
    case 'REMOVE_PROJECT_TYPE':
      return {
        ...state,
        types: state.types.filter(type => type.id !== action.type_id)
      }
    case 'SET_PROJECT_PANEL':
      return {
        ...state,
        panel: action.panel
      }
    case 'SET_SELECTED_TOOLBAR_ANNOTATION_TYPE':
      return {
        ...state,
        toolbarAnnotation: action.toolbarAnnotation
      }
    default:
      return state;
  }
}